import { Routes, Route } from 'react-router-dom';
import Dashboard from '../page/Dashboard';
import AllJobs from '../page/AllJobs';
import AddJob from '../page/AddJob';
import ErrorPage from '../page/Error';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/all-jobs" element={<AllJobs />} />
      <Route path="/add-job" element={<AddJob />} />
      <Route path="*" element={<ErrorPage />} />
      <Route path="/edit-job/:id" element={<AddJob />} />
    </Routes>
  );
}
